export const refs = {
  // modals
  exerciseModal: document.querySelector('#exercise-modal'),
  ratingModal: document.querySelector('#give-rating-modal'),
  ratingBlock: document.querySelector('.rating-modal-rating-block'),
  ratingDisplay: document.querySelector('.rating-modal-rating'),
};
